import React, { useContext } from 'react';
import ReactSVG from 'react-svg';
import { ThemeContext } from '../../store/ThemeProvider';
interface ICheckBox {
  checked: boolean;
  onClick?: () => void;
}
export default (props: ICheckBox) => {
  const { checked, onClick } = props;
  const { mainColor } = useContext(ThemeContext);
  const style = {
    width: 16,
    height: 16,
    verticalAlign: 'text-bottom',
    display: 'inline-block',
    marginRight: 2,
    fill: mainColor
  };
  return (
    <ReactSVG
      wrapper={'span'}
      onClick={onClick}
      style={style}
      src={
        checked
          ? require('../../svg/checked.svg')
          : require('../../svg/unchecked.svg')
      }
    />
  );
};
